export class WindowLoadedEvent {
  event = 'page loaded' as const;
}